import { render, staticRenderFns } from "./PromptServiceMenu.vue?vue&type=template&id=038febe0"
import script from "./PromptServiceMenu.vue?vue&type=script&lang=js"
export * from "./PromptServiceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports